const STORAGE_KEY = "stalkie_onboarding";

export interface OnboardingContext {
  username: string;
  previewSessionId: string;
  monitorId: string | null;
  previewData: {
    username: string;
    fullName?: string | null;
    profilePicUrl?: string | null;
    biography?: string | null;
    followingCount: number;
    followersCount: number;
    femaleCount?: number;
    maleCount?: number;
    followings?: {
      username: string;
      fullName?: string | null;
      profilePicUrl?: string | null;
      gender: string;
    }[];
  } | null;
}

export function setOnboardingContext(data: Partial<OnboardingContext>): void {
  try {
    const existing = getOnboardingContext();
    const merged = { ...existing, ...data };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch {
    // sessionStorage unavailable
  }
}

export function getOnboardingContext(): Partial<OnboardingContext> {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as Partial<OnboardingContext>;
  } catch {
    return {};
  }
}

export function clearOnboardingContext(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage unavailable
  }
}

export function hasOnboardingContext(): boolean {
  const ctx = getOnboardingContext();
  return !!ctx.username;
}
